import type { InviteStatus } from '../types/invitee'

/**
 * Statuses that allow adding co-applicants
 */
export const ALLOW_PROGRESS_STATUSES: InviteStatus[] = [
  'User Registered',
  'Application Started',
  'Application Incomplete',
  'Application Complete',
  'Application Paid',
  'Awaiting External',
  'In Progress',
]

/**
 * Mobile grid (InviteeGrid): show resend / edit / add-co-applicant for these status labels.
 * Includes both "Invite Send" and "Invite Sent" — APIs and copy differ but behavior matches the list view.
 */
export const GRID_ACTION_VISIBLE_STATUSES = [
  'Application Incomplete',
  'Invite Send',
  'Invite Sent',
  'Application Started',
] as const

export function shouldShowInviteeGridActions(status: string | undefined): boolean {
  if (!status) return false
  return (GRID_ACTION_VISIBLE_STATUSES as readonly string[]).includes(status)
}

/**
 * Invite status options for filter
 */
export const INVITE_STATUS_OPTIONS = [
  { value: 'Liberty', label: 'Liberty Invites' },
  { value: 'Entrata', label: 'API Trigger Invites' },
] as const

/**
 * Per page options for pagination
 */
export const PER_PAGE_OPTIONS = [15, 30, 50, 100] as const

/**
 * Sortable columns
 */
export const SORTABLE_COLUMNS = [
  'agent_name',
  'applicant_name',
  'email',
  'mobile_no',
  'property_name',
  'company_name',
  'sales_manager',
  'rent_amount',
  'income',
  'unit_number',
  'status',
  'created_at',
  'invite_status_date',
  'invite_code',
] as const
